<template>
  <div class="">
     <!-- 查询表单 -->
     <div>
      <el-form ref="orderRemarkForm" :model="orderRemarkForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="关键字">
                <el-input v-model="orderRemarkForm.keyword"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getListSearchOrderRemarkMatch">查询</el-button>
            <el-button type="primary" @click="addOrderRemarkMatch">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            prop="keyword"
            label="关键字">
          </el-table-column>
          <el-table-column
            prop="optionCode"
            label="选项编码">
          </el-table-column>
          <el-table-column
            prop="optionName"
            label="选项名称">
          </el-table-column>
          <el-table-column
            prop="attrCode"
            label="选项值编码">
          </el-table-column>
          <el-table-column
            prop="attrName"
            label="选项值名称">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="deleteOrderRemarkMatch(scope.row)" type="text" size="small">删除</el-button> 
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog title="新增关键字" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editOrderRemarkForm" :model="editOrderRemarkForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="关键字">
              <el-input clearable v-model="editOrderRemarkForm.keyword"></el-input>
            </el-form-item>
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="editOrderRemarkForm.categoryId"
                placeholder="请选择"
                @change="valuationClassChange()"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评估分类">
              <el-radio-group v-model="valuationClass" @change="valuationClassChange()" v-removeAriaHidden>
                <el-radio   :label="25">成色信息</el-radio>
                <el-radio   :label="26">功能信息</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="评估选项">
              <el-select
                v-model="editOrderRemarkForm.optionId"
                placeholder="请选择"
                filterable
                @change="changeValuetionOption()"
              >
                <el-option
                  v-for="item in valuationOptionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选项值">
              <el-select
                v-model="editOrderRemarkForm.attrId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in selectOptionValueList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      orderRemarkForm: {
        keyword: null
      },
      valuationClass:25,
    
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editOrderRemarkForm: {
        id: null,
        keyword:null,
        categoryId:null,
        optionId:null,
        attrId:null
      },
      loading: false,
      updateFlag:false,
      categoryOptions: [],
      selectOptionValueList:[],
      valuationOptionList:[],
      editorFormRules: {
        attrId: [
          { required: true, message: '请选择选项值', trigger: 'change' },
        ]
      },
    }
  },
  watch:{},
  computed:{},
  methods:{
    deleteOrderRemarkMatch(row){
      let self = this
      self.$api.deleteOrderRemarkMatch(row).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getListSearchOrderRemarkMatch()
              }
            })
    },
    changeValuetionOption(){
      let self=this
      this.getSelectFuncationAndConditionOptionValueList(this.editOrderRemarkForm.optionId)
      self.$set(self.editOrderRemarkForm, "attrId", null);
    },
 
    valuationClassChange(){
      let self=this
      this.getValuationOptionList(this.editOrderRemarkForm.categoryId,this.valuationClass)
      this.$set(self.editOrderRemarkForm, "optionId", null);
      this.$set(self.editOrderRemarkForm, "attrId", null);
    },
    //获取品牌下的sku信息
    skuTree(val) {
      let self = this;
      self.$api
        .skuTree({
          brandId: val,
        })
        .then((res) => {
          self.skuInfo = res.data;
        });
    },
    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    // 请求分类列表，提供编辑时选择用
    getValuationOptionList(categoryId,LinkageTypeId) {
      let self = this;
      self.$api
        .getValuationOptionList({
          categoryId: categoryId,
          linkageTypeId: LinkageTypeId
        })
        .then((res) => {
          if (res.code === 200) {
            self.valuationOptionList = res.data;
          }
        });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectFuncationAndConditionOptionValueList(optionId) {
      let self = this;
      self.$api
        .getSelectFuncationAndConditionOptionValueList({
          optionId: optionId
        })
        .then((res) => {
          if (res.code === 200) {
            self.selectOptionValueList = res.data;
          }
        });
    },
     // 请求分类列表，提供编辑时选择用
     getSelectOptionValueList(categoryId, brandId,LinkageTypeId) {
      let self = this;
      self.$api
        .getSelectOptionValueList({
          categoryId: categoryId,
          brandId: brandId,
          LinkageTypeId: LinkageTypeId
        })
        .then((res) => {
          if (res.code === 200) {
            self.selectOptionValueList = res.data;
          }
        });
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getListSearchOrderRemarkMatch()
    }, 

    // 获取门店列表
    getListSearchOrderRemarkMatch() {
      let self  = this;
      self.$api.listSearchOrderRemarkMatch({
        page: self.currentPage,
        size: self.pageSize,
        keyword: self.orderRemarkForm.keyword || null,
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

        // 添加城市经理
    addOrderRemarkMatch() {
      this.editOrderRemarkForm = {
        id: null,
        keyword:null,
        categoryId:null,
        optionId:null,
        attrId:null
      },
      this.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editOrderRemarkForm'].validate((valid) => {
        if (valid) {
            self.$api.saveOrderRemarkMatch({keyword:self.editOrderRemarkForm.keyword,
              categoryId:self.editOrderRemarkForm.categoryId,
              optionId:self.editOrderRemarkForm.optionId,
              attrId:self.editOrderRemarkForm.attrId}).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getListSearchOrderRemarkMatch()
                this.closeEditorDlg()
              }
            })
          }
      });
     
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getListSearchOrderRemarkMatch();
    self.getSelectOptions("category", "categoryOptions");
  }
}
</script>
<style lang="less" scoped>
 
    /deep/ .el-radio__original {
      display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
    }
    
    /deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
        box-shadow: none !important;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>